import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { TeamSettingNames } from '../../api/teams/getTeams';

type ChangeTeamSettingEventData = {
  teamId: string;
  original_settings: TeamSettingNames;
  saved_settings: TeamSettingNames;
};

export class ChangeTeamSettingEventAdapter extends EventAdapter<ChangeTeamSettingEventData> {
  protected intercomEventKey = null;

  constructor({
    teamId,
    original_settings,
    saved_settings,
  }: ChangeTeamSettingEventData) {
    super();

    this.eventData = {
      teamId,
      original_settings,
      saved_settings,
    };
  }
  protected amplitudeEventFunction = function addQuizModalEvent(
    event: ChangeTeamSettingEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.TeamsChangeSetting, event);
  };
}
